import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { selectLoginTokenInfo } from "../../../redux/features/loginRegisterSlice";
import { mobileMenuData } from "./sidebarLinks";

const normalizePath = (p) => {
  if (!p) return "/";
  const noQuery = p.split("?")[0].split("#")[0];
  if (noQuery === "/") return "/";
  return noQuery.replace(/\/+$/, "");
};

const isLinkActive = (currentPath, linkPath) => {
  const a = normalizePath(currentPath);
  const b = normalizePath(linkPath);
  if (a === b) return true;
  // Treat sub-routes as active so the icon stays highlighted on nested screens
  if (b !== "/" && (a === b || a.startsWith(b + "/"))) return true;
  return false;
};

const MobileFooter = () => {
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const translate = useLanguageTranslate();
  const { pathname } = useLocation();
  return (
    <div
      className="bottom_bar fixed bottom-0 left-0 right-0 z-10 gap-1 bg-white backdrop-blur-[20px] list-none flex w-[393px] max-w-[100%] justify-between items-start px-7 pt-3 border-t pb-[max(2.25rem,env(safe-area-inset-bottom))] min-h-[88px] w-full max767:z-[9]"
      style={{ WebkitTapHighlightColor: "transparent" }}
    >
      {mobileMenuData.map((link, linkIndex) => (
        <li
          key={linkIndex}
          className={`list-none flex w-14 flex-col items-center gap-1 shrink-0 ${
            link.showIfIsLoggedIn == true && !loginTokenInfo ? "" : ""
          } ${isLinkActive(pathname, link.link) ? "active" : "inActive"}`}
          style={{ WebkitTapHighlightColor: "transparent" }}
        >
          <Link
            to={link.link}
            state={{ navigatedFromLink: link.text }}
            className={`text-center relative contents flex-row items-center  ${
              link.disabled
                ? "pointer-events-none opacity-50 text-[#005574]"
                : ""
            }`}
            style={{
              WebkitTapHighlightColor: "transparent",
              WebkitTouchCallout: "none",
            }}
          >
            <span className="inline-flex justify-center items-center">
                <img
                  src={link.icon}
                  alt={translate(link.text_en, link.text_ar)}
                  className="w-6 h-6"
                  draggable={false}
                  style={{ WebkitUserSelect: "none", WebkitTouchCallout: "none" }}
                />
              </span>
            <span className={`text-[10px] not-italic font-semibold truncate text-center leading-[normal] tracking-[-0.06px] transition-colors duration-150 ease-out ${pathname == link.link ? "text-[#005574]" : "text-[#84919A]"}`}>
              {translate(link.text_en, link.text_ar)}
            </span>
          </Link>
        </li>
      ))}
    </div>
  );
};

export default MobileFooter;
